/** A combination term is either a load case or the field part of one (sub load case). */
export const isSubLoadCase = (loadCase: LoadCase | SubLoadCase): loadCase is SubLoadCase =>
  'load_case' in loadCase

/** The load case a combination term refers to, unwrapping a sub load case. */
export const unwrapLoadCase = (loadCase: LoadCase | SubLoadCase): LoadCase =>
  isSubLoadCase(loadCase) ? loadCase.load_case : loadCase

/**
 * Field label of a sub load case in the documented span numbering (`f1`, `f1-f2`, `fk,l`,
 * `A`). Older results without a label fall back to the pattern field index.
 */
export const subLoadCaseFieldLabel = (subLoadCase: SubLoadCase): string =>
  subLoadCase.field_label ?? (subLoadCase.always_loaded ? 'A' : `f${subLoadCase.field_number + 1}`)
